export const TicketsPageSessionStorageKeys = {
  Date: 'reloadCurrentTicketsDate',
  Flow: 'reloadCurrentTicketsFlow',
};

const setSessionStorageItem = (key: string, value: string) => {
  sessionStorage.setItem(key, value);
};

const removeSessionStorageItem = (key: string) => {
  sessionStorage.removeItem(key);
};

const getSessionStorageItem = (key: string): string | null => {
  return sessionStorage.getItem(key);
};

export const saveBuyTicketsPageSessionStorage = (
  flow: string,
  date: string,
) => {
  setSessionStorageItem(TicketsPageSessionStorageKeys.Flow, flow);
  setSessionStorageItem(TicketsPageSessionStorageKeys.Date, date);
};

export const getBuyTicketsPageSessionStorage = () => {
  const flow = getSessionStorageItem(TicketsPageSessionStorageKeys.Flow);
  const date = getSessionStorageItem(TicketsPageSessionStorageKeys.Date);

  return { flow, date };
};

export const clearBuyTicketsPageSessionStorage = () => {
  removeSessionStorageItem(TicketsPageSessionStorageKeys.Flow);
  removeSessionStorageItem(TicketsPageSessionStorageKeys.Date);
};
